import { httpClient } from '@/services/http/httpClient'

export async function deleteUserMemberProject({
  projectId,
  userId,
}: {
  projectId: string
  userId: string
}) {
  return await httpClient.delete(
    `/projects/portfolio-projects/${projectId}/member/${userId}`,
  )
}
